var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7,.7,6.3,0,3.5,2.8.7,0,0,.7,2.8,3.5,0,6.3.7,7,3.5,4.2,6.3,7,7,6.3,4.2,3.5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }